import React, { Component } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Cgv from "@/pages/Cgv";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[#EBECE8] flex items-center justify-center p-6">
          <div className="max-w-md text-center border border-black/10 rounded-xl bg-white p-8">
            <p className="font-tech text-xs uppercase tracking-[0.25em] text-citek-greenDark mb-3">
              CITEK — Erreur
            </p>
            <p className="text-zinc-600 text-sm mb-6">
              Une erreur est survenue lors de l'affichage de la page.
            </p>
            <Link to="/" className="inline-block bg-citek-green text-black font-semibold px-5 py-2.5 rounded-md text-sm">
              Retour à l'accueil
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/cgv" element={<Cgv />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster theme="light" richColors position="top-right" />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
